    (function(){
      'use strict';

      // Escape untrusted strings (product titles/vendors from JSON APIs, recent
      // searches from localStorage) before inserting into innerHTML.
      function escapeHtml(s){
        return String(s == null ? '' : s).replace(/[&<>"']/g, function(c){
          return { '&':'&amp;', '<':'&lt;', '>':'&gt;', '"':'&quot;', "'":'&#39;' }[c];
        });
      }

      // ---- 1. Sticky header scrolled state ----
      var header = document.getElementById('abt-header');
      if(header){
        var onScroll = function(){
          if(window.scrollY > 8) header.classList.add('is-scrolled');
          else header.classList.remove('is-scrolled');
        };
        window.addEventListener('scroll', onScroll, { passive: true });
        onScroll();
      }

      // ---- 2. Mobile drawer ----
      var burger = document.querySelector('.abt-burger');
      var drawer = document.getElementById('abt-mobile-drawer');
      var overlay = document.getElementById('abt-mobile-overlay');
      var closeBtn = document.querySelector('.abt-mobile-drawer__close');
      function openDrawer(){
        drawer.classList.add('is-open');
        overlay.classList.add('is-open');
        burger.classList.add('is-open');
        burger.setAttribute('aria-expanded', 'true');
        drawer.setAttribute('aria-hidden', 'false');
        document.body.style.overflow = 'hidden';
      }
      function closeDrawer(){
        drawer.classList.remove('is-open');
        overlay.classList.remove('is-open');
        burger.classList.remove('is-open');
        burger.setAttribute('aria-expanded', 'false');
        drawer.setAttribute('aria-hidden', 'true');
        document.body.style.overflow = '';
      }
      if(burger){
        burger.addEventListener('click', function(){
          if(drawer.classList.contains('is-open')) closeDrawer();
          else openDrawer();
        });
      }
      if(overlay) overlay.addEventListener('click', closeDrawer);
      if(closeBtn) closeBtn.addEventListener('click', closeDrawer);
      if(drawer){
        drawer.querySelectorAll('a').forEach(function(a){
          a.addEventListener('click', function(){ setTimeout(closeDrawer, 100); });
        });
      }

      // ---- 3. Smooth scroll for anchor links ----
      document.querySelectorAll('a[href^="/#"], a[href^="#"]').forEach(function(a){
        a.addEventListener('click', function(e){
          var href = a.getAttribute('href');
          var hash = href.indexOf('#') >= 0 ? href.slice(href.indexOf('#')) : '';
          if(!hash || hash.length < 2) return;
          // only intercept same-page anchors
          if(href.startsWith('/#') && location.pathname !== '/') return; // let it navigate
          var target = document.querySelector(hash);
          if(!target) return;
          e.preventDefault();
          var rect = target.getBoundingClientRect();
          var offset = rect.top + window.scrollY - 80;
          window.scrollTo({ top: offset, behavior: 'smooth' });
        });
      });

      // ---- 4. Scroll reveal ----
      if('IntersectionObserver' in window){
        var io = new IntersectionObserver(function(entries){
          entries.forEach(function(e){
            if(e.isIntersecting){
              e.target.classList.add('is-revealed');
              io.unobserve(e.target);
            }
          });
        }, { rootMargin: '0px 0px 100px 0px', threshold: 0.01 });
        function bind(){
          document.querySelectorAll('[data-reveal]:not(.is-revealed)').forEach(function(el){ io.observe(el); });
        }
        bind();
        window.__abtReveal = 1; // signal the head failsafe that reveals are handled
        // re-bind when new sections appear (lazy templates)
        var mo = new MutationObserver(function(){ bind(); });
        mo.observe(document.body, { childList: true, subtree: true });
        // Failsafe: nothing already on screen may rest half-faded (IO races, bfcache, print)
        function revealInView(){
          var vh = window.innerHeight || 800;
          document.querySelectorAll('[data-reveal]:not(.is-revealed)').forEach(function(el){
            var r = el.getBoundingClientRect();
            if(r.top < vh + 200 && r.bottom > -200) el.classList.add('is-revealed');
          });
        }
        setTimeout(revealInView, 1500);
        window.addEventListener('load', function(){ setTimeout(revealInView, 300); });
      } else {
        window.__abtReveal = 1;
        document.querySelectorAll('[data-reveal]').forEach(function(el){ el.classList.add('is-revealed'); });
      }

      // ---- 4-pre-2. Wishlist (localStorage-based, persistent) ----
      (function wishlist(){
        var STORAGE_KEY = 'abt_wishlist';
        function get(){
          try { return JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]'); }
          catch(e){ return []; }
        }
        function set(arr){ try { localStorage.setItem(STORAGE_KEY, JSON.stringify(arr)); } catch(e){} }
        function isSaved(handle){ return get().indexOf(handle) >= 0; }
        function toggle(handle){
          var arr = get();
          var i = arr.indexOf(handle);
          if(i >= 0) arr.splice(i, 1);
          else arr.unshift(handle);
          set(arr);
          return arr.indexOf(handle) >= 0;
        }
        function svgHtml(){
          return '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/></svg>';
        }
        function insertButtons(){
          // Retired: hearts on card images competed with the Add-to-bag pill. Wishlist lives in the header and the PDP Save button.
        }
        function updateHeaderCount(){
          var arr = get();
          var el = document.getElementById('abt-wishlist-count');
          if(el){ el.textContent = arr.length; el.dataset.count = arr.length; }
        }
        insertButtons();
        updateHeaderCount();
        var mo = new MutationObserver(insertButtons);
        mo.observe(document.body, { childList: true, subtree: true });

        // Wishlist page: render saved items
        var wishlistPage = document.querySelector('[data-wishlist-page]');
        if(wishlistPage){
          var emptyEl = document.getElementById('abt-wishlist-empty');
          var gridEl = document.getElementById('abt-wishlist-grid');
          var footerEl = document.getElementById('abt-wishlist-footer');
          var clearBtn = document.getElementById('abt-wishlist-clear');
          // Brand-CDN fallback map for product images when /products/X.js doesn't have featured_image
          var WISHLIST_FALLBACK = {}; // hardcoded URLs removed (brief)

          function fetchProduct(handle){
            return fetch('/products/' + handle + '.js')
              .then(function(r){ return r.ok ? r.json() : null; })
              .catch(function(){ return null; });
          }

          function renderPage(){
            var arr = get();
            if(arr.length === 0){
              if(emptyEl) emptyEl.hidden = false;
              if(gridEl) gridEl.hidden = true;
              if(footerEl) footerEl.hidden = true;
              return;
            }
            if(emptyEl) emptyEl.hidden = true;
            if(gridEl) gridEl.hidden = false;
            if(footerEl) footerEl.hidden = false;

            // Pre-render skeletons
            gridEl.innerHTML = arr.map(function(handle){
              return '<div class="abt-wishlist-item" data-handle="' + handle + '" data-loading="1">' +
                '<div class="abt-wishlist-item__img-wrap"><div class="abt-prod-card__img"></div></div>' +
                '<div class="abt-wishlist-item__body"><span class="abt-wishlist-item__name">Loading…</span></div>' +
              '</div>';
            }).join('');

            // Fetch each product and replace skeleton
            Promise.all(arr.map(fetchProduct)).then(function(results){
              results.forEach(function(product, i){
                var handle = arr[i];
                var node = gridEl.querySelector('[data-handle="' + handle + '"]');
                if(!node) return;
                var imgUrl = WISHLIST_FALLBACK[handle] || '';
                var name = handle.replace(/-/g, ' ').replace(/\b\w/g, function(c){ return c.toUpperCase(); });
                var price = '';
                var brand = '';
                var url = '/products/' + handle;
                if(product){
                  name = product.title;
                  if(product.featured_image) imgUrl = product.featured_image;
                  if(product.price !== undefined){
                    var p = product.price / 100;
                    price = '$' + p.toFixed(2);
                  }
                  brand = product.vendor || '';
                  url = product.url || url;
                }
                var imgHtml = imgUrl ? '<img src="' + imgUrl + '" alt="' + name.replace(/"/g,'&quot;') + '" loading="lazy">' : '<div class="abt-img-ph"><span class="abt-img-ph__mark">Aesthetics<br><em>by&nbsp;Talli</em></span></div>';
                node.dataset.loading = '';
                node.innerHTML =
                  '<a href="' + url + '" class="abt-wishlist-item__img-wrap">' +
                    '<div class="abt-prod-card__img">' + imgHtml + '</div>' +
                  '</a>' +
                  '<div class="abt-wishlist-item__body">' +
                    (brand ? '<p class="abt-wishlist-item__brand">' + escapeHtml(brand) + '</p>' : '') +
                    '<a href="' + url + '" class="abt-wishlist-item__name">' + escapeHtml(name) + '</a>' +
                    (price ? '<p class="abt-wishlist-item__price">' + price + '</p>' : '') +
                    '<div class="abt-wishlist-item__actions">' +
                      '<a href="' + url + '" class="btn btn--gold">View product</a>' +
                      '<button type="button" class="abt-wishlist-item__remove" data-wishlist-remove="' + handle + '" aria-label="Remove">Remove</button>' +
                    '</div>' +
                  '</div>';
              });
              gridEl.querySelectorAll('[data-wishlist-remove]').forEach(function(btn){
                btn.addEventListener('click', function(){
                  toggle(btn.dataset.wishlistRemove);
                  renderPage();
                  updateHeaderCount();
                  if(window.ABT_toast) window.ABT_toast('Removed from wishlist');
                });
              });
            });
          }
          renderPage();
          if(clearBtn){
            clearBtn.addEventListener('click', function(){
              if(!confirm('Clear all wishlist items?')) return;
              set([]);
              renderPage();
              updateHeaderCount();
              if(window.ABT_toast) window.ABT_toast('Wishlist cleared');
            });
          }

          // Add-all-to-cart
          var addAllBtn = document.getElementById('abt-wishlist-add-all');
          if(addAllBtn){
            addAllBtn.addEventListener('click', function(){
              var handles = get();
              if(handles.length === 0) return;
              addAllBtn.disabled = true;
              addAllBtn.textContent = 'Adding…';
              // Fetch each product to get variant ID, then bulk add
              Promise.all(handles.map(function(h){
                return fetch('/products/' + h + '.js').then(function(r){ return r.ok ? r.json() : null; }).catch(function(){ return null; });
              })).then(function(products){
                var items = products
                  .filter(function(p){ return p && p.available !== false && p.variants && p.variants[0]; })
                  .map(function(p){ return { id: p.variants[0].id, quantity: 1 }; });
                if(items.length === 0){
                  addAllBtn.textContent = 'Nothing available';
                  setTimeout(function(){ addAllBtn.disabled = false; addAllBtn.textContent = 'Add all to cart'; }, 2000);
                  return;
                }
                fetch('/cart/add.js', {
                  method: 'POST',
                  headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
                  body: JSON.stringify({ items: items })
                }).then(function(r){ return r.json(); }).then(function(){
                  addAllBtn.disabled = false;
                  addAllBtn.textContent = 'Add all to cart';
                  if(window.ABT_toast) window.ABT_toast('Added ' + items.length + ' items to cart');
                  setTimeout(function(){ if(window.ABT_openCart) window.ABT_openCart(); }, 300);
                  // Refresh cart count
                  fetch('/cart.js').then(function(r){return r.json();}).then(function(cart){
                    document.querySelectorAll('.abt-cart-count').forEach(function(el){
                      el.textContent = cart.item_count; el.dataset.count = cart.item_count;
                    });
                  }).catch(function(){});
                }).catch(function(){
                  addAllBtn.textContent = 'Failed — retry';
                  setTimeout(function(){ addAllBtn.disabled = false; addAllBtn.textContent = 'Add all to cart'; }, 2000);
                });
              });
            });
          }

          // Share wishlist (encodes handles in URL)
          var shareBtn = document.getElementById('abt-wishlist-share');
          if(shareBtn){
            shareBtn.addEventListener('click', function(){
              var handles = get();
              if(handles.length === 0) return;
              var url = window.location.origin + '/?items=' + encodeURIComponent(handles.join(','));
              if(navigator.share){
                navigator.share({ title: 'My wishlist', url: url }).catch(function(){});
              } else if(navigator.clipboard){
                navigator.clipboard.writeText(url).then(function(){
                  if(window.ABT_toast) window.ABT_toast('Wishlist link copied');
                });
              }
            });
          }

          // Auto-import shared wishlist from URL ?items=handle1,handle2
          var params = new URLSearchParams(window.location.search);
          var sharedItems = params.get('items');
          if(sharedItems){
            var existing = get();
            sharedItems.split(',').forEach(function(h){
              h = h.trim();
              if(h && existing.indexOf(h) < 0) existing.unshift(h);
            });
            set(existing.slice(0, 20));
            // Strip query param
            window.history.replaceState({}, '', window.location.pathname);
            renderPage();
            updateHeaderCount();
            if(window.ABT_toast) window.ABT_toast('Wishlist imported');
          }

          // ---- Wishlist slide-out overlay (works with no merchant-created page) ----
          var wlDrawer = document.getElementById('abt-wishlist-drawer');
          var wlOverlay = document.getElementById('abt-wishlist-overlay');
          if(wlDrawer && wlOverlay){
            var openWishlist = function(){
              renderPage();
              updateHeaderCount();
              wlDrawer.classList.add('is-open');
              wlOverlay.classList.add('is-open');
              wlDrawer.setAttribute('aria-hidden', 'false');
              document.body.classList.add('abt-no-scroll');
            };
            var closeWishlist = function(){
              wlDrawer.classList.remove('is-open');
              wlOverlay.classList.remove('is-open');
              wlDrawer.setAttribute('aria-hidden', 'true');
              document.body.classList.remove('abt-no-scroll');
            };
            window.ABT_openWishlist = openWishlist;
            window.ABT_closeWishlist = closeWishlist;
            document.addEventListener('click', function(e){
              var opener = e.target.closest('[data-open-wishlist]');
              if(opener){ e.preventDefault(); openWishlist(); return; }
              if(e.target.closest('[data-close-wishlist]')){ e.preventDefault(); closeWishlist(); }
            });
            document.addEventListener('keydown', function(e){
              if(e.key === 'Escape' && wlDrawer.classList.contains('is-open')) closeWishlist();
            });
          }
        }
      })();

      // ---- 4-pre. Page load fade-in + image .is-loaded class ----
      document.documentElement.classList.remove('abt-loading');
      (function imageLoadHandler(){
        function markLoaded(img){ if(img.complete && img.naturalWidth > 0) img.classList.add('is-loaded'); }
        function bind(){
          document.querySelectorAll('.abt-prod-card__img img, .abt-shop-studio-card__img img, .abt-recently__img img, .abt-pick__img img, .abt-routine-step__img img').forEach(function(img){
            if(img.dataset.abtImgBound) return;
            img.dataset.abtImgBound = '1';
            if(img.complete) markLoaded(img);
            else img.addEventListener('load', function(){ markLoaded(img); }, { once: true });
          });
        }
        bind();
        var mo = new MutationObserver(bind);
        mo.observe(document.body, { childList: true, subtree: true });
      })();

      // ---- 4a. Custom gold cursor follower — REMOVED (was distracting) ----
      // Previously rendered a 24px gold circle that followed the cursor and
      // scaled on hover. Users found it weird. Disabled. Native cursor only.

      // ---- 4a1. Welcome offer ribbon dismiss + persist ----
      (function welcomeRibbon(){
        var ribbon = document.getElementById('abt-welcome-ribbon');
        var closeBtn = document.getElementById('abt-welcome-ribbon-close');
        if(!ribbon || !closeBtn) return;
        var KEY = 'abt_welcome_dismissed';
        try {
          if(localStorage.getItem(KEY)){ ribbon.classList.add('is-hidden'); return; }
        } catch(e){}
        closeBtn.addEventListener('click', function(e){
          e.preventDefault();
          e.stopPropagation();
          ribbon.classList.add('is-hidden');
          try { localStorage.setItem(KEY, '1'); } catch(e){}
        });
      })();

      // ---- 4a1b. Cart free-shipping progress bar — REMOVED (no free-shipping promo) ----

      // ---- 4a2. Shop filter chips (legacy V42/V43) + Add-to-bag (all card grids, incl. bestsellers rail) ----
      (function shopStudioFilters(){
        var sec = document.querySelector('.abt-shop-studio--v42, .abt-shop-studio--v43, .abt-shop-studio--v44');
        var chips = sec ? sec.querySelectorAll('.abt-shop-chip') : [];
        var cards = sec ? sec.querySelectorAll('.abt-shop-studio-card, .abt-shop-v44__card') : [];
        chips.forEach(function(chip){
          chip.addEventListener('click', function(){
            var filter = chip.getAttribute('data-filter');
            chips.forEach(function(c){
              c.classList.toggle('is-active', c === chip);
              c.setAttribute('aria-selected', c === chip ? 'true' : 'false');
            });
            cards.forEach(function(card){
              var cat = card.getAttribute('data-cat');
              var match = filter === 'all' || cat === filter;
              card.classList.toggle('is-hidden', !match);
            });
            // Update count chip
            var allChip = document.querySelector('.abt-shop-studio--v42 .abt-shop-chip[data-filter="all"] .abt-shop-chip__count');
            if(allChip && filter === 'all'){
              allChip.textContent = cards.length;
            }
          });
        });
        // Wire wishlist hearts on shop cards to existing wishlist system
        var hearts = sec ? sec.querySelectorAll('.abt-shop-studio-card__wishlist') : [];
        hearts.forEach(function(heart){
          var handle = heart.getAttribute('data-product-handle');
          if(!handle) return;
          try {
            var list = JSON.parse(localStorage.getItem('abt_wishlist') || '[]');
            if(list.indexOf(handle) !== -1) heart.classList.add('is-active');
          } catch(e){}
          heart.addEventListener('click', function(e){
            e.preventDefault();
            e.stopPropagation();
            try {
              var l = JSON.parse(localStorage.getItem('abt_wishlist') || '[]');
              var i = l.indexOf(handle);
              if(i === -1){ l.push(handle); heart.classList.add('is-active'); }
              else { l.splice(i, 1); heart.classList.remove('is-active'); }
              localStorage.setItem('abt_wishlist', JSON.stringify(l));
              var countEl = document.querySelector('[data-wishlist-count]');
              if(countEl) countEl.textContent = l.length;
              document.dispatchEvent(new CustomEvent('abt:wishlistChange', { detail: { list: l } }));
            } catch(err){}
          });
        });

        // Wire Add-to-bag buttons — delegated document-wide so cards added later (drawer upsells, load-more) always work
        document.addEventListener('click', function(e){
          var btn = e.target.closest('[data-add-to-cart]');
          if(!btn || btn.disabled) return;
            e.preventDefault();
            e.stopPropagation();
            var variantId = btn.getAttribute('data-variant-id');
            var handle = btn.getAttribute('data-product-handle');
            var title = btn.getAttribute('data-product-title') || 'Product';
            // If no real variant id (draft product, fallback data), send shopper to PDP instead
            if(!variantId || variantId === ''){
              window.location.href = '/products/' + handle;
              return;
            }
            btn.setAttribute('disabled', '');
            fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
              body: JSON.stringify({ items: [{ id: parseInt(variantId, 10), quantity: 1 }] })
            }).then(function(r){ return r.json(); }).then(function(data){
              btn.classList.add('is-added');
              btn.removeAttribute('disabled');
              // Update cart count in header if present
              fetch('/cart.js').then(function(r){ return r.json(); }).then(function(cart){
                var countEls = document.querySelectorAll('[data-cart-count], .abt-cart-count, .abt-header__cart-count');
                countEls.forEach(function(el){ el.textContent = cart.item_count; });
                document.dispatchEvent(new CustomEvent('abt:cartUpdate', { detail: { cart: cart } }));
                // Open cart drawer via its own opener — fetches + renders contents and overlay
                if(window.ABT_openCart) window.ABT_openCart();
                // Toast notification
                showAddToast(title);
              }).catch(function(){});
              // Reset button after 2.5s
              setTimeout(function(){ btn.classList.remove('is-added'); }, 2500);
            }).catch(function(err){
              btn.removeAttribute('disabled');
              // Fallback to PDP on error
              window.location.href = '/products/' + handle;
            });
        });

        // Toast helper
        function showAddToast(title){
          var existing = document.querySelector('.abt-shop-toast');
          if(existing) existing.remove();
          var toast = document.createElement('div');
          toast.className = 'abt-shop-toast';
          toast.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" width="18" height="18"><polyline points="20 6 9 17 4 12"/></svg><span><strong>Added to bag</strong><br>' + title + '</span>';
          document.body.appendChild(toast);
          setTimeout(function(){ toast.classList.add('is-visible'); }, 10);
          setTimeout(function(){ toast.classList.remove('is-visible'); }, 3500);
          setTimeout(function(){ toast.remove(); }, 4000);
        }
      })();

      // ---- 4b. Sticky desktop "Book Treatment" pill ----
      var stickyBook = document.getElementById('abt-sticky-book');
      if(stickyBook){
        var heroEl = document.querySelector('.abt-hero');
        var threshold = heroEl ? heroEl.offsetHeight * 0.65 : 600;
        var ticking = false;
        function updateStickyBook(){
          var y = window.scrollY || window.pageYOffset;
          // Hide near footer to avoid overlap with footer CTA
          var nearBottom = (window.innerHeight + y) > (document.documentElement.scrollHeight - 400);
          if(y > threshold && !nearBottom){
            stickyBook.classList.add('is-visible');
          } else {
            stickyBook.classList.remove('is-visible');
          }
          ticking = false;
        }
        window.addEventListener('scroll', function(){
          if(!ticking){ requestAnimationFrame(updateStickyBook); ticking = true; }
        }, { passive: true });
        updateStickyBook();
      }

      // ---- 5. Testimonials carousel (driven by data attribute on track) ----
      var quoteTracks = document.querySelectorAll('[data-quote-carousel]');
      quoteTracks.forEach(function(track){
        var slides = track.querySelectorAll('.abt-quote');
        var dotsWrap = track.parentElement.querySelector('.abt-quotes__dots');
        if(!slides.length) return;
        var idx = 0;
        var dots = [];
        if(dotsWrap){
          slides.forEach(function(_, i){
            var d = document.createElement('button');
            d.className = 'abt-quote-dot';
            d.setAttribute('aria-label', 'Testimonial ' + (i+1));
            d.addEventListener('click', function(){ show(i); reset(); });
            dotsWrap.appendChild(d);
            dots.push(d);
          });
        }
        function show(i){
          idx = (i + slides.length) % slides.length;
          slides.forEach(function(s, j){ s.classList.toggle('is-active', j === idx); });
          dots.forEach(function(d, j){ d.classList.toggle('is-active', j === idx); });
        }
        show(0);
        var timer = setInterval(function(){ show(idx + 1); }, 6500);
        function reset(){ clearInterval(timer); timer = setInterval(function(){ show(idx + 1); }, 6500); }
      });

      // ---- 6. Hero loaded class for ken burns ----
      document.querySelectorAll('.abt-hero').forEach(function(h){
        requestAnimationFrame(function(){ requestAnimationFrame(function(){ h.classList.add('is-loaded'); }); });
      });


      // ---- 9. Page intro animation cleanup ----
      var intro = document.getElementById('abt-intro');
      if(intro){
        // Only show on home page first load
        var alreadyShown = sessionStorage.getItem('abt-intro-shown');
        if(alreadyShown || document.body.dataset.template !== 'index'){
          intro.classList.add('abt-intro--done');
        } else {
          sessionStorage.setItem('abt-intro-shown', '1');
          setTimeout(function(){ intro.classList.add('abt-intro--done'); }, 2200);
        }
      }

      // ---- 10. Counter animation for stats ----
      var counters = document.querySelectorAll('[data-counter]');
      if(counters.length && 'IntersectionObserver' in window){
        var countObs = new IntersectionObserver(function(entries){
          entries.forEach(function(e){
            if(!e.isIntersecting) return;
            var el = e.target;
            if(el.dataset.counted) return;
            el.dataset.counted = '1';
            var target = parseInt(el.dataset.counter, 10);
            var suffix = el.dataset.suffix || '';
            var dur = 1800;
            var start = performance.now();
            var ease = function(t){ return 1 - Math.pow(1 - t, 3); };
            var step = function(now){
              var t = Math.min(1, (now - start) / dur);
              var val = Math.round(target * ease(t));
              el.textContent = val + suffix;
              if(t < 1) requestAnimationFrame(step);
            };
            requestAnimationFrame(step);
            countObs.unobserve(el);
          });
        }, { threshold: 0.4 });
        counters.forEach(function(c){ countObs.observe(c); });
      }

      // ---- 11a. Brand-CDN product image fallback (universal) ----
      var PRODUCT_IMG_MAP = {}; // hardcoded URLs removed (brief) — see PRODUCT-IMAGE-URLS.md
      window.ABT_PRODUCT_IMG_MAP = PRODUCT_IMG_MAP;

      function injectProductImages(scope){
        var root = scope || document;
        // Pattern A: .abt-prod-card[data-handle] with inner .abt-prod-card__img
        root.querySelectorAll('.abt-prod-card[data-handle]').forEach(function(card){
          if(card.dataset.abtImgChecked) return;
          var handle = card.dataset.handle;
          var url = PRODUCT_IMG_MAP[handle];
          if(!url) { card.dataset.abtImgChecked = '1'; return; }
          var slot = card.querySelector('.abt-prod-card__img');
          if(!slot) return;
          var existing = slot.querySelector('img');
          var setImage = function(){
            slot.innerHTML = '';
            var i = document.createElement('img');
            i.src = url;
            i.alt = card.querySelector('.abt-prod-card__name')?.textContent || handle;
            i.loading = 'lazy';
            i.onerror = function(){ this.style.display = 'none'; };
            slot.appendChild(i);
          };
          if(!existing) { setImage(); card.dataset.abtImgChecked = '1'; return; }
          if(existing.complete){
            if(!existing.naturalWidth) setImage();
            card.dataset.abtImgChecked = '1';
          } else {
            existing.addEventListener('load', function(){
              if(!existing.naturalWidth) setImage();
              card.dataset.abtImgChecked = '1';
            });
            existing.addEventListener('error', function(){
              setImage();
              card.dataset.abtImgChecked = '1';
            });
          }
        });
        // Pattern B: standalone .abt-prod-card__img[data-handle] (used in cart line items)
        root.querySelectorAll('.abt-prod-card__img[data-handle]').forEach(function(slot){
          if(slot.dataset.abtImgChecked) return;
          if(slot.closest('.abt-prod-card[data-handle]')) return; // already handled above
          var handle = slot.dataset.handle;
          var url = PRODUCT_IMG_MAP[handle];
          if(!url) { slot.dataset.abtImgChecked = '1'; return; }
          var existing = slot.querySelector('img');
          var setImage = function(){
            slot.innerHTML = '';
            var i = document.createElement('img');
            i.src = url;
            i.alt = handle;
            i.loading = 'lazy';
            i.onerror = function(){ this.style.display = 'none'; };
            slot.appendChild(i);
          };
          if(!existing) { setImage(); slot.dataset.abtImgChecked = '1'; return; }
          // If existing has empty src OR data-needs-fallback, replace immediately
          if(!existing.getAttribute('src') || existing.dataset.needsFallback === '1'){
            setImage(); slot.dataset.abtImgChecked = '1'; return;
          }
          if(existing.complete){
            if(!existing.naturalWidth) setImage();
            slot.dataset.abtImgChecked = '1';
          } else {
            existing.addEventListener('load', function(){
              if(!existing.naturalWidth) setImage();
              slot.dataset.abtImgChecked = '1';
            });
            existing.addEventListener('error', function(){
              setImage();
              slot.dataset.abtImgChecked = '1';
            });
          }
        });
      }
      injectProductImages();
      new MutationObserver(function(){ injectProductImages(); })
        .observe(document.body, { childList: true, subtree: true });

      // ---- 11b. Skin Quiz (interactive multi-step modal) ----
      (function initQuiz(){
        var modal = document.getElementById('abt-quiz-modal');
        if(!modal) return;
        var closeBtn = document.getElementById('abt-quiz-close');
        var progressSteps = modal.querySelectorAll('.abt-quiz-prog__step');
        var questions = Array.from(modal.querySelectorAll('.abt-quiz-q'));
        var resultPane = document.getElementById('abt-quiz-result');
        var backBtn = document.getElementById('abt-quiz-back');
        var countLabel = document.getElementById('abt-quiz-count');
        var navBar = document.getElementById('abt-quiz-nav');
        var emailInput = document.getElementById('abt-quiz-email');
        var nameInput = document.getElementById('abt-quiz-name');
        var submitBtn = document.getElementById('abt-quiz-submit');
        var skipEmailBtn = document.getElementById('abt-quiz-skip-email');

        var current = 0;
        var answers = {};

        function showStep(i){
          current = Math.max(0, Math.min(questions.length - 1, i));
          questions.forEach(function(q, idx){ q.classList.toggle('is-active', idx === current); });
          progressSteps.forEach(function(s, idx){
            s.classList.toggle('is-done', idx < current);
            s.classList.toggle('is-active', idx === current);
          });
          countLabel.textContent = 'Step ' + (current + 1) + ' of ' + questions.length;
          backBtn.disabled = current === 0;
          navBar.style.display = '';
          resultPane.classList.remove('is-active');
          if(current === questions.length - 1) {
            navBar.style.display = 'none'; // email step has own submit button
          }
        }

        function openModal(){
          modal.classList.add('is-open');
          modal.setAttribute('aria-hidden', 'false');
          document.body.style.overflow = 'hidden';
          // Reset to step 1
          current = 0; answers = {};
          questions.forEach(function(q){
            q.querySelectorAll('.abt-quiz-option').forEach(function(o){ o.classList.remove('is-selected'); });
          });
          if(emailInput) emailInput.value = '';
          if(nameInput) nameInput.value = '';
          showStep(0);
        }
        function closeModal(){
          modal.classList.remove('is-open');
          modal.setAttribute('aria-hidden', 'true');
          document.body.style.overflow = '';
        }

        // Wire up all triggers (any link/button to #routine-finder or #start-quiz)
        document.querySelectorAll('a[href="#start-quiz"], button[data-open-quiz], [data-quiz-trigger]').forEach(function(t){
          t.addEventListener('click', function(e){ e.preventDefault(); openModal(); });
        });

        // Also wire up the existing "Start the Quiz" button on home page
        var quizSection = document.getElementById('routine-finder');
        if(quizSection){
          var startBtns = quizSection.querySelectorAll('a.btn--gold, a.btn--lg');
          startBtns.forEach(function(b){
            if(b.textContent && /start the quiz|find your routine|take the quiz/i.test(b.textContent)){
              b.addEventListener('click', function(e){ e.preventDefault(); openModal(); });
            }
          });
        }

        closeBtn.addEventListener('click', closeModal);
        modal.addEventListener('click', function(e){
          if(e.target === modal) closeModal();
        });
        document.addEventListener('keydown', function(e){
          if(e.key === 'Escape' && modal.classList.contains('is-open')) closeModal();
        });

        backBtn.addEventListener('click', function(){ showStep(current - 1); });

        // Wire up each option button
        modal.querySelectorAll('.abt-quiz-option').forEach(function(opt){
          opt.addEventListener('click', function(){
            var qEl = opt.closest('.abt-quiz-q');
            var qKey = qEl.dataset.q;
            // Mark selected
            qEl.querySelectorAll('.abt-quiz-option').forEach(function(o){ o.classList.remove('is-selected'); });
            opt.classList.add('is-selected');
            answers[qKey] = opt.dataset.value;
            // Small delay then advance
            setTimeout(function(){ showStep(current + 1); }, 250);
          });
        });

        submitBtn.addEventListener('click', function(){
          var email = (emailInput.value || '').trim();
          // Allow submission without email
          if(email && !/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email)){
            emailInput.style.borderColor = '#c0392b';
            emailInput.focus();
            return;
          }
          answers.email = email;
          answers.name = (nameInput.value || '').trim();
          submitQuiz();
        });

        skipEmailBtn.addEventListener('click', function(){
          answers.email = '';
          answers.name = '';
          submitQuiz();
        });

        var retakeBtn = document.getElementById('abt-quiz-retake');
        if(retakeBtn) retakeBtn.addEventListener('click', function(){
          // Reset
          current = 0; answers = {};
          questions.forEach(function(q){
            q.querySelectorAll('.abt-quiz-option').forEach(function(o){ o.classList.remove('is-selected'); });
          });
          if(emailInput) emailInput.value = '';
          if(nameInput) nameInput.value = '';
          showStep(0);
        });

        function submitQuiz(){
          // Show results
          renderResult();
          // Fire off the form submission to Shopify Customer API (newsletter signup)
          if(answers.email){
            try {
              var form = new FormData();
              form.append('form_type', 'customer');
              form.append('utf8', '✓');
              form.append('contact[email]', answers.email);
              if(answers.name) form.append('contact[first_name]', answers.name);
              form.append('contact[tags]', 'quiz, ' + (answers.concern || ''));
              form.append('contact[note]', JSON.stringify(answers));
              fetch('/contact', { method: 'POST', body: form, credentials: 'same-origin' }).catch(function(){});
            } catch(e) {}
          }
        }

        function renderResult(){
          // Hide questions, show result
          questions.forEach(function(q){ q.classList.remove('is-active'); });
          navBar.style.display = 'none';
          progressSteps.forEach(function(s){ s.classList.add('is-done'); });
          resultPane.classList.add('is-active');

          // Build the personalized routine
          var c = answers.concern || 'maintain';
          var t = answers.type || 'normal';
          var commit = answers.commit || 'moderate';
          var treatment = answers.treatment || 'yes-local';
          var nameGreeting = answers.name ? answers.name : 'you';

          var routineLib = {
            // AM essentials
            cleanser_basic: { name: 'Ultra Gentle Gel Cleanser', desc: 'Face Reality · daily cleanser that respects the barrier.', handle: 'ultra-gentle-gel-cleanser' },
            cleanser_mandelic: { name: 'Mandelic Face & Body Wash', desc: 'Face Reality · gentle resurfacing cleanser, ideal for acne-prone skin.', handle: 'mandelic-face-and-body-wash' },
            cleanser_acne: { name: 'Acne Face & Body Wash', desc: 'Face Reality · benzoyl peroxide cleanser for active breakouts.', handle: 'acne-face-and-body-wash' },
            cleanser_barrier: { name: 'Barrier Balance Creamy Cleanser', desc: 'Face Reality · for sensitive, compromised barrier skin.', handle: 'barrier-balance-creamy-cleanser' },
            cleanser_calming: { name: 'Calming Facial Toner', desc: 'Face Reality · soothes and balances after cleansing.', handle: 'calming-facial-toner' },

            // Treatment serums
            serum_glycolic: { name: '10% Glycolic Serum', desc: 'Face Reality · resurfacing serum for texture & tone.', handle: '10-glycolic-serum' },
            serum_glycolic_low: { name: '5% Glycolic Serum', desc: 'Face Reality · gentler resurfacing, perfect for beginners.', handle: '5-glycolic-serum' },
            serum_mandelic: { name: '8% L-Mandelic Acid Serum', desc: 'Face Reality · clears breakouts without aggression.', handle: '8-l-mandelic-acid' },
            serum_mandelic_strong: { name: '15% L-Mandelic Acid Serum', desc: 'Face Reality · advanced serum for stubborn acne & PIH.', handle: '15-l-mandelic-acid' },
            serum_retinol: { name: 'Retinol B3 Serum', desc: 'Face Reality · retinaldehyde for fine lines & texture.', handle: 'retinol-b3-serum' },
            serum_peptide: { name: 'Retinol Peptide Serum', desc: 'Face Reality · advanced anti-aging corrective serum.', handle: 'retinol-peptide-serum' },
            serum_aox: { name: 'Antioxidant Peptide Serum', desc: 'Face Reality · brightens, protects, smooths.', handle: 'antioxidant-peptide-serum' },
            serum_glowtone: { name: 'GlowTone Corrective Serum', desc: 'Face Reality · targets hyperpigmentation & uneven tone.', handle: 'glowtone-corrective' },
            serum_biome: { name: 'Biome Balancing Serum', desc: 'SIV · pre/probiotic serum that restores the skin microbiome.', handle: 'biome-balancing-serum' },
            serum_ha: { name: 'Restorative HA Serum', desc: 'Hydrinity · luxe hydration for plump, dewy skin.', handle: 'restorative-ha-serum' },
            serum_hyacyn: { name: 'Hyacyn Active Spray', desc: 'Hydrinity · calming antimicrobial spray.', handle: 'hyacyn-active-spray' },

            // Moisturizers
            moist_clearderma: { name: 'ClearDerma Moisturizer', desc: 'Face Reality · oil-free moisturizer for acne-prone skin.', handle: 'clearderma-moisturizer' },
            moist_cran: { name: 'Cran-Peptide Cream', desc: 'Face Reality · rich, nourishing cream for dry skin.', handle: 'cran-peptide-cream' },
            moist_comfort: { name: 'Comfort Cream', desc: 'Glymed · soothing barrier-repair moisturizer.', handle: 'comfort-cream' },
            moist_barrier: { name: 'Barrier Care Gel Cream', desc: 'Face Reality · lightweight barrier-strengthening hydrator.', handle: 'barrier-care-gel-cream' },
            moist_hb: { name: 'HydraBalance Gel', desc: 'Face Reality · oil-free hydrator, gel finish.', handle: 'hydrabalance-gel' },
            moist_hr: { name: 'HydraRemedy Gel Serum', desc: 'Face Reality · ultra-hydrating gel for thirsty skin.', handle: 'hydraremedy-gel-serum' },

            // SPF
            spf30: { name: 'Daily SPF 30+ Lotion', desc: 'Face Reality · broad-spectrum, every-day SPF.', handle: 'daily-spf30-lotion' },
            spf_mineral: { name: 'Mineral Matte SPF 28', desc: 'Face Reality · zinc-based mineral SPF, matte finish.', handle: 'mineral-matte-spf28' },
            spf_power: { name: 'Power Mineral SPF 50', desc: 'Face Reality · high-protection mineral SPF.', handle: 'power-mineral-spf-50' },

            // Add-ons
            mask_clay: { name: 'Soothing Clay Mask', desc: 'Face Reality · weekly clarifying mask, especially for acne.', handle: 'soothing-clay-mask' },
            mask_brighten: { name: 'Brighten C Mask', desc: 'Face Reality · vitamin C brightening mask.', handle: 'brighten-c-mask' },
            mask_hydra: { name: 'HydraCalm Mask', desc: 'Face Reality · soothing weekly hydration mask.', handle: 'hydracalm-mask' },
            mask_restorative: { name: 'Restorative HA Mask', desc: 'Hydrinity · luxe overnight HA mask.', handle: 'restorative-ha-mask' },
            lip: { name: 'LUXE Lip Hydrator', desc: 'Hydrinity · plumping, hydrating lip treatment.', handle: 'luxe-lip-hydrator' }
          };

          var picks = [];

          // Cleanser
          if(c === 'acne') picks.push(routineLib.cleanser_mandelic);
          else if(t === 'sensitive' || c === 'sensitive') picks.push(routineLib.cleanser_barrier);
          else if(t === 'dry') picks.push(routineLib.cleanser_basic);
          else picks.push(routineLib.cleanser_basic);

          // Treatment serum (AM or PM depending on routine)
          if(c === 'acne'){
            picks.push(commit === 'quick' ? routineLib.serum_mandelic : routineLib.serum_mandelic_strong);
          } else if(c === 'pigment'){
            picks.push(routineLib.serum_glowtone);
            if(commit !== 'quick') picks.push(routineLib.serum_glycolic_low);
          } else if(c === 'aging'){
            picks.push(commit === 'full' ? routineLib.serum_peptide : routineLib.serum_retinol);
            if(commit !== 'quick') picks.push(routineLib.serum_aox);
          } else if(c === 'texture'){
            picks.push(routineLib.serum_glycolic);
            if(commit !== 'quick') picks.push(routineLib.serum_aox);
          } else if(c === 'sensitive'){
            picks.push(routineLib.serum_biome);
            picks.push(routineLib.serum_hyacyn);
          } else {
            picks.push(routineLib.serum_aox);
          }

          // Hydration
          if(t === 'dry') picks.push(routineLib.serum_ha);
          else if(commit === 'full') picks.push(routineLib.serum_ha);

          // Moisturizer
          if(c === 'acne' || t === 'oily') picks.push(routineLib.moist_clearderma);
          else if(t === 'sensitive' || c === 'sensitive') picks.push(routineLib.moist_comfort);
          else if(t === 'dry') picks.push(routineLib.moist_cran);
          else picks.push(routineLib.moist_hb);

          // SPF
          if(t === 'oily' || c === 'acne') picks.push(routineLib.spf_mineral);
          else if(c === 'pigment' || c === 'aging') picks.push(routineLib.spf_power);
          else picks.push(routineLib.spf30);

          // Optional weekly mask if user has time
          if(commit !== 'quick'){
            if(c === 'acne') picks.push(routineLib.mask_clay);
            else if(c === 'pigment') picks.push(routineLib.mask_brighten);
            else if(t === 'dry' || c === 'aging') picks.push(routineLib.mask_restorative);
            else picks.push(routineLib.mask_hydra);
          }

          // Cap at 6 picks for readability
          picks = picks.slice(0, 6);

          var listEl = document.getElementById('abt-quiz-products');
          listEl.innerHTML = picks.map(function(p, i){
            return '<div class="abt-quiz-rx">' +
              '<span class="abt-quiz-rx__num">' + (i + 1).toString().padStart(2, '0') + '</span>' +
              '<div class="abt-quiz-rx__body">' +
                '<p class="abt-quiz-rx__name">' + p.name + '</p>' +
                '<p class="abt-quiz-rx__desc">' + p.desc + '</p>' +
              '</div>' +
              '<a href="/products/' + p.handle + '" class="abt-quiz-rx__link">View →</a>' +
            '</div>';
          }).join('');

          // Treatment recommendation
          var treatments = {
            acne: { name: 'Acne Boot Camp + Consult', desc: '75 min · $140 — Personalized plan and first treatment for clearing skin.', book: 'https://aestheticsbytalli.glossgenius.com/services' },
            texture: { name: 'Advanced Glow Treatment', desc: '80 min · $240 — Dermaplaning + LED + enzyme + lymphatic massage. Transformative.', book: 'https://aestheticsbytalli.glossgenius.com/services' },
            pigment: { name: 'BiorepeelC13 Chemical Peel', desc: '30 min · $250 — Targets hyperpigmentation and evens skin tone.', book: 'https://aestheticsbytalli.glossgenius.com/services' },
            aging: { name: 'Advanced Glow Treatment', desc: '80 min · $240 — Stimulates collagen, smooths, brightens.', book: 'https://aestheticsbytalli.glossgenius.com/services' },
            sensitive: { name: 'Custom Facial', desc: '75 min · $165 — Gentle, customized for sensitive skin, calms and restores.', book: 'https://aestheticsbytalli.glossgenius.com/services' },
            maintain: { name: 'Custom Facial', desc: '75 min · $165 — Monthly maintenance for healthy, radiant skin.', book: 'https://aestheticsbytalli.glossgenius.com/services' }
          };
          var tEl = document.getElementById('abt-quiz-treatment');
          var section = document.getElementById('abt-quiz-treatment-section');
          if(treatment === 'products'){
            section.style.display = 'none';
          } else {
            section.style.display = '';
            var rec = treatments[c] || treatments.maintain;
            tEl.innerHTML = '<div class="abt-quiz-rx">' +
              '<span class="abt-quiz-rx__num">★</span>' +
              '<div class="abt-quiz-rx__body">' +
                '<p class="abt-quiz-rx__name">' + rec.name + '</p>' +
                '<p class="abt-quiz-rx__desc">' + rec.desc + '</p>' +
              '</div>' +
              '<a href="' + rec.book + '" target="_blank" rel="noopener" class="abt-quiz-rx__link">Book →</a>' +
            '</div>';
          }

          // Personalize title
          var concernCopy = {
            acne: 'A plan to clear your skin.',
            texture: 'A routine to bring back your glow.',
            pigment: 'A plan to even your skin tone.',
            aging: 'A clinical routine for firm, glowing skin.',
            sensitive: 'A barrier-first routine for calm skin.',
            maintain: 'A maintenance routine for healthy skin.'
          };
          document.getElementById('abt-quiz-result-title').textContent = concernCopy[c] || 'Your skin\'s plan is ready.';
          if(answers.name){
            document.getElementById('abt-quiz-result-sub').textContent = 'Built around your skin, ' + answers.name + '. Final fine-tuning happens in your consultation.';
          } else {
            document.getElementById('abt-quiz-result-sub').textContent = 'Built around your answers. Final fine-tuning happens in your consultation.';
          }
        }

      })();

      // ---- 11a-quickadd. RETIRED — cards now carry a real Add-to-bag pill in markup (variant-accurate, always visible) ----

      // ---- 11a-services. Homepage treatments: expand the full menu ----
      document.addEventListener('click', function(e){
        var t = e.target.closest('[data-expand-services]');
        if(!t) return;
        var list = document.getElementById('abt-services-list');
        if(list){ list.classList.remove('is-collapsed'); }
        t.remove();
      });

      // ---- 11a-cart. Cart drawer ----
      (function initCartDrawer(){
        var overlay = document.getElementById('abt-cart-overlay');
        var drawer = document.getElementById('abt-cart-drawer');
        var closeBtn = document.getElementById('abt-cart-drawer-close');
        var body = document.getElementById('abt-cart-drawer-body');
        var itemsEl = document.getElementById('abt-cart-drawer-items');
        var emptyEl = drawer ? drawer.querySelector('.abt-cart-drawer__empty') : null;
        var foot = document.getElementById('abt-cart-drawer-foot');
        var subtotalEl = document.getElementById('abt-cart-drawer-subtotal');
        if(!drawer || !overlay) return;
        function fmt(cents){ return '$' + (cents/100).toFixed(2).replace(/\.00$/,''); }
        function brandCdnFallback(handle){
          if(window.ABT_PRODUCT_IMG_MAP && window.ABT_PRODUCT_IMG_MAP[handle]) return window.ABT_PRODUCT_IMG_MAP[handle];
          return null;
        }
        function render(cart){
          // Update badges everywhere
          document.querySelectorAll('.abt-cart-count').forEach(function(b){
            b.textContent = cart.item_count;
            b.dataset.count = cart.item_count;
          });
          if(cart.item_count === 0){
            if(emptyEl) emptyEl.style.display = '';
            if(itemsEl){ itemsEl.hidden = true; itemsEl.innerHTML = ''; }
            if(foot) foot.hidden = true;
            return;
          }
          if(emptyEl) emptyEl.style.display = 'none';
          if(itemsEl) itemsEl.hidden = false;
          if(foot) foot.hidden = false;
          if(subtotalEl) subtotalEl.textContent = fmt(cart.items_subtotal_price || cart.total_price);
          // Sync cart note from cart data
          var noteEl = document.getElementById('abt-cart-drawer-note');
          if(noteEl && cart.note !== undefined && document.activeElement !== noteEl){
            noteEl.value = cart.note || '';
          }
          var html = cart.items.map(function(it, idx){
            var imgSrc = it.image ? it.image : '';
            if(!imgSrc){ var fb = brandCdnFallback(it.handle); if(fb) imgSrc = fb; }
            var brand = it.vendor ? '<p class="abt-cart-drawer-item__brand">' + escapeHtml(it.vendor) + '</p>' : '';
            return ''
              + '<li class="abt-cart-drawer-item" data-line="' + (idx + 1) + '" data-handle="' + it.handle + '">'
              +   '<a href="' + it.url + '" class="abt-cart-drawer-item__img">'
              +     (imgSrc ? '<img src="' + imgSrc + '" alt="' + (it.title || '').replace(/"/g, '&quot;') + '" loading="lazy">' : '<div class="abt-img-ph"><span class="abt-img-ph__mark">Aesthetics<br><em>by&nbsp;Talli</em></span></div>')
              +   '</a>'
              +   '<div class="abt-cart-drawer-item__info">'
              +     brand
              +     '<a href="' + it.url + '" class="abt-cart-drawer-item__name">' + escapeHtml(it.product_title) + '</a>'
              +     '<p class="abt-cart-drawer-item__price">' + fmt(it.original_price) + '</p>'
              +     '<div class="abt-cart-drawer-item__controls">'
              +       '<div class="abt-cart-drawer-item__qty">'
              +         '<button type="button" data-qty="-1" aria-label="Decrease">−</button>'
              +         '<input type="number" value="' + it.quantity + '" min="0" max="99" data-qty-input aria-label="Quantity">'
              +         '<button type="button" data-qty="1" aria-label="Increase">+</button>'
              +       '</div>'
              +       '<button type="button" class="abt-cart-drawer-item__remove" data-remove>Remove</button>'
              +     '</div>'
              +   '</div>'
              +   '<p class="abt-cart-drawer-item__line">' + fmt(it.final_line_price) + '</p>'
              + '</li>';
          }).join('');
          if(itemsEl) itemsEl.innerHTML = html;
        }
        function fetchCart(){ return fetch('/cart.js',{headers:{'Accept':'application/json'}}).then(function(r){return r.json();}).catch(function(){ return {item_count:0, items:[]}; }); }
        function updateLine(line, quantity){
          return fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({line:parseInt(line,10),quantity:parseInt(quantity,10)})}).then(function(r){return r.json();}).then(function(c){ render(c); return c; }).catch(function(){ if(window.ABT_toast) window.ABT_toast('Could not update cart — please try again'); });
        }
        function open(){
          drawer.classList.add('is-open'); overlay.classList.add('is-open');
          drawer.setAttribute('aria-hidden','false');
          document.body.style.overflow = 'hidden';
          fetchCart().then(render);
        }
        function close(){
          drawer.classList.remove('is-open'); overlay.classList.remove('is-open');
          drawer.setAttribute('aria-hidden','true');
          document.body.style.overflow = '';
        }
        window.ABT_openCart = open;
        window.ABT_closeCart = close;
        // Cart note: debounced save to Shopify cart
        var noteInput = document.getElementById('abt-cart-drawer-note');
        if(noteInput){
          var noteTimer;
          noteInput.addEventListener('input', function(){
            clearTimeout(noteTimer);
            noteTimer = setTimeout(function(){
              fetch('/cart/update.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
                body: JSON.stringify({ note: noteInput.value })
              }).catch(function(){});
            }, 600);
          });
        }
        // Toast helper
        var toast = document.getElementById('abt-toast');
        var toastMsg = document.getElementById('abt-toast-msg');
        var toastTimer;
        window.ABT_toast = function(text){
          // Also announce to screen readers via live region
          var live = document.getElementById('abt-sr-live');
          if(live && text){ live.textContent = ''; setTimeout(function(){ live.textContent = text; }, 50); }
          if(!toast) return;
          if(toastMsg && text) toastMsg.textContent = text;
          toast.classList.add('is-visible');
          toast.setAttribute('aria-hidden', 'false');
          clearTimeout(toastTimer);
          toastTimer = setTimeout(function(){
            toast.classList.remove('is-visible');
            toast.setAttribute('aria-hidden', 'true');
          }, 2400);
        };
        document.querySelectorAll('[data-open-cart]').forEach(function(t){ t.addEventListener('click', function(e){ e.preventDefault(); open(); }); });
        document.querySelectorAll('[data-close-cart]').forEach(function(t){ t.addEventListener('click', function(e){ if(t.tagName !== 'A') e.preventDefault(); close(); }); });
        if(closeBtn) closeBtn.addEventListener('click', close);
        overlay.addEventListener('click', close);
        document.addEventListener('keydown', function(e){ if(e.key === 'Escape' && drawer.classList.contains('is-open')) close(); });
        // Cart item qty + remove handlers (delegated)
        if(body){
          body.addEventListener('click', function(e){
            var item = e.target.closest('.abt-cart-drawer-item');
            if(!item) return;
            var line = item.dataset.line;
            if(e.target.matches('[data-remove]')){
              updateLine(line, 0);
              return;
            }
            if(e.target.matches('[data-qty]')){
              var input = item.querySelector('[data-qty-input]');
              var step = parseInt(e.target.dataset.qty, 10);
              var v = Math.max(0, Math.min(99, parseInt(input.value || '1', 10) + step));
              input.value = v;
              updateLine(line, v);
            }
          });
          body.addEventListener('change', function(e){
            if(e.target.matches('[data-qty-input]')){
              var item = e.target.closest('.abt-cart-drawer-item');
              if(!item) return;
              var v = Math.max(0, parseInt(e.target.value || '0', 10));
              e.target.value = v;
              updateLine(item.dataset.line, v);
            }
          });
        }
        // Initial render with current state
        fetchCart().then(render);
        // Hook into add-to-cart events to auto-open
        window.ABT_cartAdded = function(){ open(); };
      })();

      // ---- 11b. Announce bar rotator ----
      (function initAnnounceRotator(){
        var msgs = document.querySelectorAll('#abt-announce .abt-announce__msg');
        if(msgs.length < 2) return;
        var i = 0;
        setInterval(function(){
          msgs[i].classList.remove('is-active');
          i = (i + 1) % msgs.length;
          msgs[i].classList.add('is-active');
        }, 4500);
      })();

      // ---- 11c. Email signup popup (delayed, persistent dismiss) ----
      (function initPopup(){
        var popup = document.getElementById('abt-popup');
        if(!popup) return;
        var closeBtn = document.getElementById('abt-popup-close');
        var dismissBtn = document.getElementById('abt-popup-dismiss');
        var form = document.getElementById('abt-popup-form');
        var dismissed = false;
        try {
          var stored = localStorage.getItem('abt-popup-dismissed');
          if(stored){
            var when = parseInt(stored, 10);
            // Re-show after 30 days
            if(Date.now() - when < 30 * 24 * 60 * 60 * 1000) dismissed = true;
          }
        } catch(e) {}
        function dismiss(){
          popup.classList.remove('is-open');
          popup.setAttribute('aria-hidden', 'true');
          try { localStorage.setItem('abt-popup-dismissed', Date.now().toString()); } catch(e) {}
        }
        if(closeBtn) closeBtn.addEventListener('click', dismiss);
        if(dismissBtn) dismissBtn.addEventListener('click', dismiss);

        // AJAX submit (no jarring reload) — mirrors the quiz newsletter capture,
        // then swaps the card to an inline thank-you.
        if(form){
          form.addEventListener('submit', function(e){
            e.preventDefault();
            var emailInput = form.querySelector('input[type=email]');
            var email = emailInput ? (emailInput.value || '').trim() : '';
            if(!email){ if(emailInput) emailInput.focus(); return; }
            var submitBtn = form.querySelector('.abt-popup__submit');
            if(submitBtn){ submitBtn.disabled = true; submitBtn.textContent = 'Joining…'; }
            var fd = new FormData();
            fd.append('form_type', 'customer'); fd.append('utf8', '✓');
            fd.append('contact[email]', email);
            fd.append('contact[tags]', 'newsletter, popup');
            var finish = function(){
              try { localStorage.setItem('abt-popup-subscribed', '1'); } catch(e){}
              try { localStorage.setItem('abt-popup-dismissed', Date.now().toString()); } catch(e){}
              popup.innerHTML = '<button class="abt-popup__close" data-popup-close aria-label="Close"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" width="16" height="16"><path d="M18 6 6 18"/><path d="m6 6 12 12"/></svg></button><p class="abt-popup__incentive">From the studio</p><h3 class="abt-popup__title">You’re in. Welcome.</h3><p class="abt-popup__lead">Check your inbox soon — Talli’s first skin note is on the way. No spam, ever.</p>';
              var c2 = popup.querySelector('[data-popup-close]');
              if(c2) c2.addEventListener('click', function(){ popup.classList.remove('is-open'); popup.setAttribute('aria-hidden','true'); });
              setTimeout(function(){ popup.classList.remove('is-open'); popup.setAttribute('aria-hidden','true'); }, 6500);
            };
            fetch('/contact', { method: 'POST', body: fd, credentials: 'same-origin' })
              .then(finish).catch(finish);
          });
        }

        // Scroll-triggered corner card. Skip if dismissed, already subscribed, or
        // on cart/checkout/account pages where it would interrupt a task.
        var subscribed = false;
        try { subscribed = localStorage.getItem('abt-popup-subscribed') === '1'; } catch(e){}
        var path = window.location.pathname || '';
        var blocked = /^\/(cart|checkout|account|challenge|password|tools)/.test(path);
        if(dismissed || subscribed || blocked) return;

        var shown = false;
        function show(){
          if(shown) return; shown = true;
          popup.classList.add('is-open');
          popup.setAttribute('aria-hidden', 'false');
          window.removeEventListener('scroll', onScroll);
        }
        function onScroll(){
          var sc = window.pageYOffset || document.documentElement.scrollTop || 0;
          var h = document.documentElement.scrollHeight - window.innerHeight;
          if(h > 0 && (sc / h) > 0.45) show();
        }
        window.addEventListener('scroll', onScroll, { passive: true });
        // Fallback for short pages: show after 35s of engaged time.
        setTimeout(function(){ if(!shown) show(); }, 35000);
      })();

      // ---- 11. Subtle parallax for hero bg ----
      var parallaxEls = document.querySelectorAll('[data-parallax]');
      if(parallaxEls.length && !matchMedia('(prefers-reduced-motion: reduce)').matches){
        var ticking = false;
        var doParallax = function(){
          parallaxEls.forEach(function(el){
            var rect = el.getBoundingClientRect();
            var speed = parseFloat(el.dataset.parallax) || 0.3;
            if(rect.bottom < 0 || rect.top > window.innerHeight) return;
            // Center the parallax around how far the hero has scrolled past the
            // top of the viewport, so at rest (hero at top) the offset is ~0
            // and the bg never shifts DOWN to expose the dark hero background
            // as a band under the header. Negative = image moves up (safe,
            // covered by the over-extended .abt-hero__bg box).
            var offset = -rect.top * speed * 0.5;
            el.style.transform = 'translate3d(0, ' + offset + 'px, 0) scale(' + (1.06 + Math.abs(offset) * 0.0002) + ')';
          });
          ticking = false;
        };
        window.addEventListener('scroll', function(){
          if(!ticking){ requestAnimationFrame(doParallax); ticking = true; }
        }, { passive: true });
        doParallax();
      }

      // ---- 11pre4. Collection filter toggle ----
      (function collectionFilter(){
        var toggle = document.getElementById('abt-coll-filter-toggle');
        var panel = document.getElementById('abt-coll-filter');
        if(!toggle || !panel) return;
        toggle.addEventListener('click', function(){
          var open = panel.classList.contains('is-open');
          if(open){
            panel.classList.remove('is-open');
            toggle.setAttribute('aria-expanded', 'false');
            setTimeout(function(){ panel.hidden = true; }, 500);
          } else {
            panel.hidden = false;
            requestAnimationFrame(function(){ panel.classList.add('is-open'); });
            toggle.setAttribute('aria-expanded', 'true');
          }
        });
      })();

      // ---- 11pre3. Search Overlay with as-you-type predictive results ----
      (function searchOverlay(){
        var overlay = document.getElementById('abt-search-overlay');
        var input = document.getElementById('abt-search-input');
        var results = document.getElementById('abt-search-results');
        var suggestions = document.getElementById('abt-search-suggestions');
        var closeBtn = document.getElementById('abt-search-close');
        if(!overlay || !input || !results) return;

        function open(){
          overlay.classList.add('is-open');
          overlay.setAttribute('aria-hidden', 'false');
          document.documentElement.style.overflow = 'hidden';
          setTimeout(function(){ input.focus(); }, 300);
        }
        function close(){
          overlay.classList.remove('is-open');
          overlay.setAttribute('aria-hidden', 'true');
          document.documentElement.style.overflow = '';
          results.innerHTML = '';
          input.value = '';
          if(suggestions) suggestions.style.display = '';
        }

        document.querySelectorAll('[data-open-search]').forEach(function(btn){
          btn.addEventListener('click', open);
        });
        if(closeBtn) closeBtn.addEventListener('click', close);
        overlay.addEventListener('click', function(e){ if(e.target === overlay) close(); });
        document.addEventListener('keydown', function(e){ if(e.key === 'Escape' && overlay.classList.contains('is-open')) close(); });

        // Recent searches via localStorage
        var RECENT_KEY = 'abt_recent_searches';
        function getRecent(){
          try { return JSON.parse(localStorage.getItem(RECENT_KEY) || '[]'); } catch(e){ return []; }
        }
        function pushRecent(q){
          if(!q || q.length < 2) return;
          var arr = getRecent().filter(function(x){ return x !== q; });
          arr.unshift(q);
          arr = arr.slice(0, 5);
          try { localStorage.setItem(RECENT_KEY, JSON.stringify(arr)); } catch(e){}
        }
        function renderRecent(){
          var arr = getRecent();
          if(arr.length === 0 || !suggestions) return;
          var recentHtml = '<p class="abt-search-overlay__label" style="margin-top:1.5rem">Recent searches</p><div class="abt-search-overlay__tags">' +
            arr.map(function(q){
              return '<a href="/search?q=' + encodeURIComponent(q) + '">' + escapeHtml(q) + '</a>';
            }).join('') + '</div>';
          // Append only if not already there
          if(!suggestions.querySelector('.abt-search-overlay__recent')){
            var div = document.createElement('div');
            div.className = 'abt-search-overlay__recent';
            div.innerHTML = recentHtml;
            suggestions.appendChild(div);
          }
        }
        renderRecent();

        // Keyboard navigation through results (Down/Up arrows)
        input.addEventListener('keydown', function(e){
          if(e.key !== 'ArrowDown' && e.key !== 'ArrowUp' && e.key !== 'Enter') return;
          var items = results.querySelectorAll('.abt-search-overlay__result');
          if(items.length === 0) return;
          var current = results.querySelector('.is-keyboard-focus');
          var idx = current ? Array.prototype.indexOf.call(items, current) : -1;
          if(e.key === 'Enter' && current){ e.preventDefault(); window.location.href = current.href; return; }
          if(e.key === 'ArrowDown'){ e.preventDefault(); idx = Math.min(items.length - 1, idx + 1); }
          else if(e.key === 'ArrowUp'){ e.preventDefault(); idx = Math.max(0, idx - 1); }
          items.forEach(function(it){ it.classList.remove('is-keyboard-focus'); });
          if(items[idx]){ items[idx].classList.add('is-keyboard-focus'); items[idx].scrollIntoView({block:'nearest'}); }
        });

        // Save search on submit
        var searchForm = overlay.querySelector('form');
        if(searchForm){
          searchForm.addEventListener('submit', function(){
            pushRecent(input.value.trim());
          });
        }

        // Debounced predictive search via Shopify's /search/suggest.json endpoint
        var debounceTimer;
        input.addEventListener('input', function(){
          var q = input.value.trim();
          clearTimeout(debounceTimer);
          if(!q || q.length < 2){
            results.innerHTML = '';
            if(suggestions) suggestions.style.display = '';
            return;
          }
          debounceTimer = setTimeout(function(){ doSearch(q); }, 220);
        });

        function doSearch(q){
          if(suggestions) suggestions.style.display = 'none';
          fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=8&resources[options][unavailable_products]=last')
            .then(function(r){ return r.ok ? r.json() : null; })
            .catch(function(){ return null; })
            .then(function(data){
              if(!data || !data.resources || !data.resources.results || !data.resources.results.products){
                results.innerHTML = '<div class="abt-search-overlay__empty">No results for "' + escapeHtml(q) + '"</div>';
                return;
              }
              var products = data.resources.results.products;
              if(products.length === 0){
                results.innerHTML = '<div class="abt-search-overlay__empty">No products match "' + escapeHtml(q) + '". Try a different term.</div>' +
                  '<a href="/search?q=' + encodeURIComponent(q) + '" class="abt-search-overlay__viewall">Search the full site →</a>';
                return;
              }
              var fb = window.ABT_FALLBACK || {};
              results.innerHTML = products.map(function(p){
                var img = (p.featured_image && p.featured_image.url) ? p.featured_image.url : (fb[p.handle] || '');
                var imgHtml = img ? '<img src="' + img + '" alt="" loading="lazy">' : '<div class="abt-img-ph"><span class="abt-img-ph__mark">Aesthetics<br><em>by&nbsp;Talli</em></span></div>';
                var price = p.price ? ('$' + (parseFloat(p.price)).toFixed(2)) : '';
                return '<a href="' + p.url + '" class="abt-search-overlay__result">' +
                  '<div class="abt-search-overlay__result-img">' + imgHtml + '</div>' +
                  '<div class="abt-search-overlay__result-body">' +
                    (p.vendor ? '<p class="abt-search-overlay__result-brand">' + escapeHtml(p.vendor) + '</p>' : '') +
                    '<p class="abt-search-overlay__result-name">' + escapeHtml(p.title) + '</p>' +
                  '</div>' +
                  (price ? '<span class="abt-search-overlay__result-price">' + price + '</span>' : '') +
                '</a>';
              }).join('');
              results.innerHTML += '<a href="/search?q=' + encodeURIComponent(q) + '" class="abt-search-overlay__viewall">View all results →</a>';
            });
        }
      })();

      // ---- 11pre2. Account dropdown ----
      (function accountMenu(){
        var toggle = document.querySelector('.abt-account-toggle');
        var menu = document.getElementById('abt-account-menu');
        if(!toggle || !menu) return;
        toggle.addEventListener('click', function(e){
          e.stopPropagation();
          var open = menu.classList.contains('is-open');
          if(open){
            menu.classList.remove('is-open');
            menu.hidden = true;
            toggle.setAttribute('aria-expanded', 'false');
          } else {
            menu.hidden = false;
            requestAnimationFrame(function(){ menu.classList.add('is-open'); });
            toggle.setAttribute('aria-expanded', 'true');
          }
        });
        document.addEventListener('click', function(e){
          if(!menu.contains(e.target) && !toggle.contains(e.target) && menu.classList.contains('is-open')){
            menu.classList.remove('is-open');
            toggle.setAttribute('aria-expanded', 'false');
            setTimeout(function(){ menu.hidden = true; }, 300);
          }
        });
        document.addEventListener('keydown', function(e){
          if(e.key === 'Escape' && menu.classList.contains('is-open')){
            menu.classList.remove('is-open');
            toggle.setAttribute('aria-expanded', 'false');
            toggle.focus();
            setTimeout(function(){ menu.hidden = true; }, 300);
          }
        });
      })();

      // ---- 11pre. Global ABT_FALLBACK map (brand-CDN product images) ----
      window.ABT_FALLBACK = window.ABT_FALLBACK || {}; // hardcoded URLs removed (brief)

      // ---- 11e. Cookie banner (V38 fix — robust dismiss) ----
      (function cookieBanner(){
        var banner = document.getElementById('abt-cookie');
        if(!banner) return;
        var KEY = 'abt_cookie_dismissed';
        // If already dismissed, remove the element entirely
        try {
          if(localStorage.getItem(KEY)){
            banner.remove();
            return;
          }
        } catch(e){}
        banner.hidden = false;
        setTimeout(function(){ banner.classList.add('is-visible'); }, 1500);
        function dismiss(e){
          if(e){ e.preventDefault(); e.stopPropagation(); }
          banner.classList.remove('is-visible');
          try { localStorage.setItem(KEY, '1'); } catch(e){}
          // Immediately hide visually + remove from DOM after transition
          banner.style.opacity = '0';
          banner.style.pointerEvents = 'none';
          setTimeout(function(){
            banner.hidden = true;
            banner.style.display = 'none';
            if(banner.parentNode) banner.parentNode.removeChild(banner);
          }, 400);
        }
        var accept = document.getElementById('abt-cookie-accept');
        var close = document.getElementById('abt-cookie-close');
        if(accept) accept.addEventListener('click', dismiss);
        if(close) close.addEventListener('click', dismiss);
        // Also dismiss on Escape key when banner is focused
        banner.addEventListener('keydown', function(e){
          if(e.key === 'Escape') dismiss(e);
        });
      })();

      // ---- 11d. aria-current on nav links matching current page ----
      (function ariaCurrentNav(){
        var path = window.location.pathname;
        document.querySelectorAll('nav a, .abt-nav a, .abt-mobile-drawer a').forEach(function(a){
          var href = a.getAttribute('href');
          if(!href) return;
          if(href.indexOf('#') !== -1) return; // anchor links jump to sections — never "the current page"
          var clean = href.split('?')[0];
          if(clean === path || (clean === '/' && path === '/')){
            a.setAttribute('aria-current', 'page');
          }
        });
      })();

      // ---- 12. Quick View Modal — RETIRED (V2 dropped its CSS; unstyled markup leaked "Loading…" into the page) ----

      // ---- 13. Focus trap utility for modals/drawers ----
      window.ABT_focusTrap = (function focusTrap(){
        var FOCUSABLE = 'a[href], button:not([disabled]), textarea:not([disabled]), input:not([disabled]):not([type="hidden"]), select:not([disabled]), [tabindex]:not([tabindex="-1"])';
        function trapIn(container){
          if(!container) return null;
          var focusables = Array.from(container.querySelectorAll(FOCUSABLE)).filter(function(el){
            return el.offsetWidth > 0 || el.offsetHeight > 0 || el === document.activeElement;
          });
          if(focusables.length === 0) return null;
          var first = focusables[0], last = focusables[focusables.length-1];
          var prevFocus = document.activeElement;
          function handler(e){
            if(e.key !== 'Tab') return;
            if(e.shiftKey){
              if(document.activeElement === first){ e.preventDefault(); last.focus(); }
            } else {
              if(document.activeElement === last){ e.preventDefault(); first.focus(); }
            }
          }
          container.addEventListener('keydown', handler);
          setTimeout(function(){ first.focus(); }, 50);
          return function release(){
            container.removeEventListener('keydown', handler);
            if(prevFocus && prevFocus.focus) try { prevFocus.focus(); } catch(e){}
          };
        }
        return { trap: trapIn };
      })();

      // ---- 14. Wire focus trap to modals (cart drawer, mobile drawer, search overlay, quick view) ----
      (function wireFocusTraps(){
        function watch(containerId, openClassName){
          var container = document.getElementById(containerId);
          if(!container) return;
          var release = null;
          var observer = new MutationObserver(function(){
            var isOpen = container.classList.contains(openClassName) || container.getAttribute('aria-hidden') === 'false';
            if(isOpen && !release){
              release = window.ABT_focusTrap.trap(container);
            } else if(!isOpen && release){
              release(); release = null;
            }
          });
          observer.observe(container, { attributes: true, attributeFilter: ['class', 'aria-hidden', 'hidden'] });
        }
        watch('abt-cart-drawer', 'is-open');
        watch('abt-mobile-drawer', 'is-open');
        watch('abt-search-overlay', 'is-open');
        watch('abt-quiz-modal', 'is-open');
      })();

      // ---- 14b. PDP actions: share, copy, save ----
      (function pdpActions(){
        var shareBtn = document.querySelector('[data-prod-share]');
        var copyBtn = document.querySelector('[data-prod-copy]');
        var saveBtn = document.querySelector('[data-prod-save]');

        if(shareBtn){
          shareBtn.addEventListener('click', function(){
            var url = window.location.href;
            var title = shareBtn.dataset.productTitle || document.title;
            if(navigator.share){
              navigator.share({ title: title, url: url }).catch(function(){});
            } else if(navigator.clipboard){
              navigator.clipboard.writeText(url).then(function(){
                if(window.ABT_toast) window.ABT_toast('Link copied to clipboard');
              });
            }
          });
        }
        if(copyBtn){
          copyBtn.addEventListener('click', function(){
            var url = window.location.href;
            if(navigator.clipboard){
              navigator.clipboard.writeText(url).then(function(){
                if(window.ABT_toast) window.ABT_toast('Link copied');
                copyBtn.classList.add('is-copied');
                setTimeout(function(){ copyBtn.classList.remove('is-copied'); }, 1500);
              });
            } else {
              // Fallback
              var ta = document.createElement('textarea');
              ta.value = url; document.body.appendChild(ta);
              ta.select(); document.execCommand('copy');
              document.body.removeChild(ta);
              if(window.ABT_toast) window.ABT_toast('Link copied');
            }
          });
        }
        if(saveBtn){
          var handle = saveBtn.dataset.prodSave;
          // Sync initial state with localStorage
          try {
            var saved = JSON.parse(localStorage.getItem('abt_wishlist') || '[]');
            if(saved.indexOf(handle) >= 0) saveBtn.classList.add('is-saved');
          } catch(e){}
          saveBtn.addEventListener('click', function(){
            try {
              var arr = JSON.parse(localStorage.getItem('abt_wishlist') || '[]');
              var i = arr.indexOf(handle);
              var nowSaved;
              if(i >= 0){ arr.splice(i, 1); nowSaved = false; }
              else { arr.unshift(handle); nowSaved = true; }
              localStorage.setItem('abt_wishlist', JSON.stringify(arr));
              saveBtn.classList.toggle('is-saved', nowSaved);
              if(window.ABT_toast) window.ABT_toast(nowSaved ? 'Saved to wishlist' : 'Removed from wishlist');
              // Update header count
              var headerCount = document.getElementById('abt-wishlist-count');
              if(headerCount){ headerCount.textContent = arr.length; headerCount.dataset.count = arr.length; }
            } catch(e){}
          });
        }
      })();

      // ---- 15. Back-to-top button (appears after long scroll) ----
      (function backToTop(){
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'abt-back-to-top';
        btn.setAttribute('aria-label', 'Back to top');
        btn.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" width="18" height="18"><line x1="12" y1="19" x2="12" y2="5"/><polyline points="5 12 12 5 19 12"/></svg>';
        btn.addEventListener('click', function(){ window.scrollTo({ top: 0, behavior: 'smooth' }); });
        document.body.appendChild(btn);
        var ticking = false;
        function update(){
          var show = (window.scrollY || window.pageYOffset) > 800;
          btn.classList.toggle('is-visible', show);
          ticking = false;
        }
        window.addEventListener('scroll', function(){
          if(!ticking){ requestAnimationFrame(update); ticking = true; }
        }, { passive: true });
      })();

    })();
/* ABT fallback-image graceful degradation -----------------------------------
   Hotlinked manufacturer-CDN product photos (data-abt-fallback) can fail if a
   brand changes/blocks its CDN. On error, swap the <img> for the branded
   placeholder so customers never see a broken-image icon. Centralized — no
   per-template markup needed. Real Shopify uploads (featured_image) are exempt. */
(function(){
  if (window.__abtImgFallbackBound) return; window.__abtImgFallbackBound = true;
  function toPlaceholder(img){
    if (!img || img.dataset.abtFailed) return;
    img.dataset.abtFailed = '1';
    var ph = document.createElement('div');
    ph.className = ('abt-img-ph ' + (img.getAttribute('class') || '')).trim();
    ph.setAttribute('role', 'img');
    ph.setAttribute('aria-label', (img.getAttribute('alt') || 'Aesthetics by Talli product') + ' — photo coming soon');
    ph.innerHTML = '<span class="abt-img-ph__mark" aria-hidden="true">Aesthetics<br><em>by&nbsp;Talli</em></span>';
    if (img.parentNode) img.parentNode.replaceChild(ph, img);
  }
  // <img> error events do not bubble — listen in the capture phase.
  document.addEventListener('error', function(e){
    var t = e.target;
    if (t && t.tagName === 'IMG' && t.hasAttribute('data-abt-fallback')) toPlaceholder(t);
  }, true);
  // Catch images that already errored before this script ran. A still-loading
  // (lazy) image has complete=false, so it is correctly left alone.
  function sweep(){
    var imgs = document.querySelectorAll('img[data-abt-fallback]');
    for (var i = 0; i < imgs.length; i++){
      if (imgs[i].complete && imgs[i].naturalWidth === 0) toPlaceholder(imgs[i]);
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', sweep);
  else sweep();
})();
// abt-cache-bust-20260603a
